// src/services/ctbService.js
import { apiClient } from './api';

/**
 * Servicio para manejar operaciones contables
 */
export const ctbService = {
  /**
   * Obtener parámetros contables para una empresa
   * @param {string} rutEmpresa - RUT de la empresa
   * @returns {Promise<Array>} - Promesa con la lista de parámetros
   */
  async getParametros(rutEmpresa) {
    return apiClient.get(`/ctb/parametros?rut_empresa=${rutEmpresa}`);
  },

  /**
   * Crear o actualizar un parámetro contable
   * @param {Object} parametro - Datos del parámetro
   * @returns {Promise<Object>} - Promesa con el parámetro creado o actualizado
   */
  async guardarParametro(parametro) {
    return apiClient.post('/ctb/parametros', parametro);
  },

  /**
   * Exportar asientos contables
   * @param {Object} datos - Datos para la exportación
   * @returns {Promise<Object>} - Promesa con el resultado de la exportación
   */
  async exportarAsientos(datos) {
    return apiClient.post('/ctb/exportar', datos);
  },

  /**
   * Obtener exportaciones contables para un período
   * @param {string} rutEmpresa - RUT de la empresa
   * @param {string} periodo - Período (YYYYMM)
   * @returns {Promise<Array>} - Promesa con la lista de exportaciones
   */
  async getExportaciones(rutEmpresa, periodo) {
    return apiClient.get(`/ctb/exportaciones?rut_empresa=${rutEmpresa}&periodo=${periodo}`);
  },

  /**
   * Obtener una exportación específica
   * @param {number} exportacionId - ID de la exportación
   * @returns {Promise<Object>} - Promesa con los datos de la exportación
   */
  async getExportacion(exportacionId) {
    return apiClient.get(`/ctb/exportaciones/${exportacionId}`);
  },

  /**
   * Obtener URL para descargar archivo de exportación
   * @param {number} exportacionId - ID de la exportación
   * @returns {string} - URL para descargar el archivo
   */
  getDownloadUrl(exportacionId) {
    return `${apiClient.BASE_URL}/ctb/exportaciones/${exportacionId}/descargar`;
  }
};